
define('text!templates/livesearch.html',[],function () { return '{{?it.domains.length > 0}}\n<ul class="livesearch-list">\n    {{~it.domains :domain}}\n    <li class="livesearch-list-item"><a data-domain="{{=domain}}" class="livesearch-link" href="/smtp/{{=domain}}">{{=domain}}</a></li>\n    {{~}}\n</ul>\n{{?}}\n';});

